import React, { useEffect } from "react";
import { gsap } from "gsap";
import "../Entry/Entry.css";

const Entry = () => {
  useEffect(() => {
    // GSAP Animation
    const image = document.querySelector(".entry-image");
    const overlay = document.querySelector(".entry-overlay");
    const text = document.querySelector(".entry-text");
    const gridBoxes = document.querySelectorAll(".grid-box");

    gsap.fromTo(
      ".grid-box",
      {
        scale: 0.2,
        opacity: 0,
        x: (index) => (index % 2 === 0 ? -100 : 100),
        y: (index) => (index % 2 === 0 ? -100 : 100),
      },
      {
        duration: 2,
        scale: 1,
        opacity: 1,
        x: 0,
        y: 0,
        stagger: 0.05,
        ease: "power3.out",
        onComplete: () => {
          // Fade in the overlay text and main text
          gsap.to(overlay, { opacity: 1, duration: 1 });
          gsap.to(text, { opacity: 1, duration: 1 });

          // Fade out the grid boxes to make them transparent after animation
          gsap.to(gridBoxes, { opacity: 0, duration: 1, stagger: 0.05 });
        },
      },
    );
  }, []);

  return (
    <div className="entry-container">
      <div className="entry-image-container">
        <img src="case.webp" alt="Entry" className="entry-image" />
        <div className="entry-overlay">
          <h1 className="entry-overlay-text">Case Results</h1>
          <p className="entry-text">
            We aim to lead in each practice and area of law we work in. Feel
            free to check our case results.
          </p>
        </div>
      </div>
      <div className="grid">
        {[...Array(25)].map((_, index) => (
          <div key={index} className="grid-box"></div>
        ))}
      </div>
    </div>
  );
};

export default Entry;
